export const CREATE_USER_CONSENT_REQUEST = 'CREATE_USER_CONSENT_REQUEST';
export const CREATE_USER_CONSENT_REQUEST_FAILURE = 'CREATE_USER_CONSENT_REQUEST_FAILURE';
export const CREATE_USER_CONSENT_REQUEST_SUCCESS = 'CREATE_USER_CONSENT_REQUEST_SUCCESS';
